import { render, staticRenderFns } from "./ProfessionalGroup.vue?vue&type=template&id=612f1f0e"
import script from "./ProfessionalGroup.vue?vue&type=script&lang=js"
export * from "./ProfessionalGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports